// extracted by mini-css-extract-plugin
export default {"card":"MetricsWidget_card__RzEVT","mobileCard":"MetricsWidget_mobileCard__gPOkZ","row_mobile":"MetricsWidget_row_mobile__rPvLD","widget_mobile":"MetricsWidget_widget_mobile__6tupM"};